import { Stack, Typography } from "@mui/material";
import { GroupedTableCardContentProps } from "src/components/cards/senec-tile/dataTypes";
import { TableGroupDivider } from "src/components/cards/senec-tile/table-card-content/TableCardElements";
import { TableCardContent } from "src/components/cards/senec-tile/table-card-content/TableCardContent";
import { useScreenSize } from "src/hooks/useScreenSize";
import { GroupedStackedCardContent } from "src/components/cards/senec-tile/table-card-content/stacked-card-content/GroupedStackedCardContent";
import { groupedDataHasIcons } from "src/components/cards/senec-tile/table-card-content/tableCardUtils";

export const GroupedTableCardContent = ({ data, highlightLabel, groupTitles = {}, horizontal }: GroupedTableCardContentProps) => {
    const { isMobile } = useScreenSize();
    const hasIconPlaceholderSpacing = groupedDataHasIcons(data);

    const horizontalStyles = { maxWidth: 420, flexGrow: 1 };

    if (isMobile) return <GroupedStackedCardContent data={data} groupTitles={groupTitles} highlightLabel={highlightLabel} />;

    const groupIds = Object.keys(data);

    return groupIds.map((groupId, index) => {
        const entries = data[groupId];
        const title = groupTitles[groupId];
        const isNotLastGroup = index < groupIds.length - 1;

        return (
            <>
                <Stack key={"content-group-" + index} sx={horizontal ? horizontalStyles : {}}>
                    {title && (
                        <Typography variant="h5" marginTop="16px" marginBottom="16px">
                            {title}
                        </Typography>
                    )}
                    <TableCardContent
                        horizontal={horizontal}
                        data={entries}
                        highlightLabel={highlightLabel}
                        hasIconPlaceholderSpacing={hasIconPlaceholderSpacing}
                    />
                    {!horizontal && isNotLastGroup && (
                        <TableGroupDivider key={"divider-" + index} sx={{ marginTop: "16px !important" }} />
                    )}
                </Stack>
                {horizontal && isNotLastGroup && (
                    <TableGroupDivider sx={{ marginRight: "32px" }} key={"divider-" + index} orientation="vertical" />
                )}
            </>
        );
    });
};
